export const HotelAd = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Hotel Ad',
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
    AdGroupName: {
      'bulk-upload-header': 'Ad Group',
    },
  },
};
